import { FormInputGroup } from 'components/form/FormInputGroup/FormInputGroup';
import { FormText } from 'components/form/FormText/FormText';
import { FormAutocomplete } from 'components/form';
import { useLazyGetSupplierDevicesEsQuery } from 'store/services';
import { ElasticsearchDeviceBodyConfig } from 'types/ElasticsearchQueries';
import { Device } from 'types';
import { useAuth } from 'hooks/useAuth';
import { useState } from 'react';
import { FormSelectOption } from 'components/form/types';

export interface InviteConsumerFormProps {
    supplierId: string;
}

export const InviteConsumerForm = ({ supplierId }: InviteConsumerFormProps) => {
    const { user } = useAuth();
    const [deviceOptions, setDeviceOptions] = useState<FormSelectOption[]>([]);
    const [searchDebounceId, setSearchDebounceId] =
        useState<NodeJS.Timeout | null>(null);
    const [searchDeviceQuery, { isLoading }] =
        useLazyGetSupplierDevicesEsQuery();

    const onSearchChange = (searchTerm: string) => {
        if (searchDebounceId !== null) clearTimeout(searchDebounceId);
        if (searchTerm) {
            setSearchDebounceId(
                setTimeout(() => {
                    searchDevices(searchTerm);
                }, 500)
            );
        }
    };

    const searchDevices = (searchTerm: string) => {
        if (user && supplierId) {
            const queryConfig: ElasticsearchDeviceBodyConfig = {
                limit: 10,
                search: searchTerm,
                sortField: 'name',
            };
            searchDeviceQuery({
                supplierId,
                userUid: user.uid,
                queryConfig,
            }).then((result) => {
                if (result?.data?.results) {
                    setDeviceOptions(
                        result.data.results.map((device: Device) => ({
                            name: `${device.name}: ${device.customer_name} (${device.shortDeviceId})`,
                            value: device.deviceId,
                        }))
                    );
                }
            });
        }
    };

    return (
        <>
            <FormInputGroup>
                <FormAutocomplete
                    label="Monitor"
                    field="deviceId"
                    options={[
                        { name: 'Please search for a monitor', value: '' },
                        ...deviceOptions,
                    ]}
                    onSearch={(searchTerm) => onSearchChange(searchTerm)}
                    isLoading={isLoading}
                />
            </FormInputGroup>
            <FormInputGroup>
                <FormText field="email" label="Email" />
            </FormInputGroup>
        </>
    );
};
